import { StateCreator } from 'zustand';

import { IGuidesStore } from './types';

export const guidesSlice: StateCreator<IGuidesStore, [], [], IGuidesStore> = (set) => ({
  guideLoadingStatus: null,
  updateGuideLoadingStatus: (status) => set({ guideLoadingStatus: status }),
});
